import React from 'react'
import { Form, Select, Skeleton, Error } from 'components/common'

type Option = {
  label: string
  value: string
}

type Props = {
  isNew: boolean
  productId: string
  setProductId: React.Dispatch<React.SetStateAction<string>>
  loading: boolean
  error: any
  options: Option[]
}

export const DiscountProductCard: React.FC<Props> = (props) => {
  const { productId, setProductId, loading, error, options, isNew } = props
  const selectedProduct: Option = options.find(
    (option: Option) => option.value === productId
  )

  if (loading) return <Skeleton active />
  if (error) return Error.render(error)

  return (
    <Form.Item name="product" label="対象施設" required={isNew}>
      {isNew ? (
        <Select
          options={options}
          style={{ width: '100%' }}
          onChange={setProductId}
        />
      ) : (
        <>
          {productId && (
            <p className="font-semibold">{selectedProduct?.label}</p>
          )}
        </>
      )}
    </Form.Item>
  )
}
